/**
* Created by vouill on 2019-02-05.
*/

<template>
  <div>
    <div class="c-content">
      <ul>
        <router-link
          v-for="(author, i) in authors"
          :to="'/intervenants/'+author.fields.slug"
          :key="i">{{ author.fields.lastname }} {{ author.fields.firstname }}</router-link>
      </ul>
    </div>
    <div>
      <select @change="handleSelectChange">
        <option
          v-for="(author, i) in authors"
          :value="author.fields.slug">{{ author.fields.lastname }} {{ author.fields.firstname }}</option>
      </select>
    </div>
  </div>
</template>

<style scoped lang="scss">
a {
  display: block;
  color: black;
  text-decoration: none;
  &:hover {
    color: #ef6c00;
  }
}
select {
  display: none;
  width: calc(100% - 2em);
  height: 30px;
  border: 1px solid orange;
  /* border-radius: 0 0; */
  background-color: white;
  margin: 1em;
  @media screen and (max-width: 700px) {
    display: block;
  }
}
.router-link-active {
  color: #ef6c00;
}
.c-content {
  min-width: 250px;
  padding: 1em;
  @media screen and (max-width: 700px) {
    display: none;
  }
}
</style>

<script>
export default {
  name: "SideMenu",
  props: { authors: Array },
  methods: {
    handleSelectChange(e) {
      this.$router.push(`/intervenants/${e.target.value}`);
    }
  },
  components: {},
  data() {
    return {};
  }
};
</script>
